import React, { useState } from 'react';
import '../styles/certification.css'; // Import CSS for styling
import certificate7 from '../assets/images/ESD 20.20 Certificate_page-0001.jpg'
import logo1 from '../assets/images/IS9001.jpeg'
import certificate1 from '../assets/images/ISO9001-UKAS -A_page-0001.jpg'
import certificate2 from '../assets/images/ISO9001-UKAS_page-0001.jpg'
import certificate3 from '../assets/images/ISO14001-A_page-0001.jpg'
import certificate4 from '../assets/images/ISO14001_page-0001.jpg'
import certificate5 from '../assets/images/ISO45001_page-0001.jpg'
import certificate6 from '../assets/images/ISO45001-A_page-0001.jpg'
// Example certificate data
const certificates = [
    { id: 1, logo: 'https://tse2.mm.bing.net/th/id/OIP.Rc8mef-ySVBnW5uXzZQ4sAHaHj?rs=1&pid=ImgDetMain', title: 'Certificate 2', img: certificate1 },
    { id: 2, logo: 'https://tse2.mm.bing.net/th/id/OIP.Rc8mef-ySVBnW5uXzZQ4sAHaHj?rs=1&pid=ImgDetMain', title: 'Certificate 3', img: certificate2 },
    { id: 3, logo: 'https://www.barton.co.uk/wp-content/uploads/sites/10/2019/07/ISO-14001-logo-400x311.jpg', title: 'Certificate 4', img: certificate3 },
    { id: 4, logo: 'https://www.barton.co.uk/wp-content/uploads/sites/10/2019/07/ISO-14001-logo-400x311.jpg', title: 'Certificate 5', img: certificate4 },
    { id: 5, logo: 'https://5.imimg.com/data5/SELLER/Default/2023/1/DM/OZ/CO/25087216/iso-45001-certification-services-1000x1000.png', title: 'Certificate 6', img: certificate5 },
    { id: 6, logo: 'https://5.imimg.com/data5/SELLER/Default/2023/1/DM/OZ/CO/25087216/iso-45001-certification-services-1000x1000.png', title: 'Certificate 7', img: certificate6 },
    { id: 7, logo: 'https://tse3.mm.bing.net/th/id/OIP.yj189Rn720X1_j8qd-dM2gAAAA?rs=1&pid=ImgDetMain', title: 'Certificate 1', img:certificate7 },
];

function Certification() {
  const [selectedCert, setSelectedCert] = useState(null);

  const openModal = (cert) => setSelectedCert(cert);
  const closeModal = () => setSelectedCert(null);

  return (
    <div className="cert-container container-about">
      <section className='about-container'><h1>OUR CERTIFICATION</h1></section>
      <br></br>
      <div className="cert-logos">
        {certificates.map((cert) => (
          <img
            key={cert.id}
            src={cert.logo}
            alt={cert.title}
            onClick={() => openModal(cert)}
            className="cert-logo"
          />
        ))}
      </div>

      {selectedCert && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>&times;</span>
            
            <img src={selectedCert.img} alt={selectedCert.title} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Certification;
